import { useUser } from './useUser';

export default () => {
    const { activeSubscription } = useUser();


    return !!activeSubscription;
};